import classNames from 'classnames/bind';
import { Dispatch, SetStateAction } from 'react';
import ChartDomestic from 'common/modal/chart/domestic';
import ChartOverseas from 'common/modal/chart/oversea';
import { getHelpLink } from 'common/modal/chart/utilChart';
import RecommendedSchedule from 'common/modal/recommend';
import { Modal, ModalPosition, IModal } from 'contexts/modalFunc';
import { IRecommend } from 'everywhere/monthly/types';
import styles from 'everywhere/index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  modal: IModal;
  selected: IRecommend;
  setModal: Dispatch<SetStateAction<IModal>>;
}

export default function RecommendModal({ modal, selected, setModal }: IProps) {
  return (
    <div className={cx('EverywhereModal')}>
      <div className={cx('header')}>
        <div className={cx('tablist')} role="tablist">
          <button
            type="button"
            className={cx('tab', 'as_chart')}
            role="tab"
            aria-selected={modal.type === Modal.FARE_CHART}
            onClick={() => {
              setModal({
                type: Modal.FARE_CHART,
                position: ModalPosition.RECOMMEND,
              });
            }}
          >
            가격그래프
          </button>
          <button
            type="button"
            className={cx('tab', 'as_recommend')}
            role="tab"
            aria-selected={modal.type === Modal.RECOMMEND}
            onClick={() => {
              setModal({
                type: Modal.RECOMMEND,
                position: ModalPosition.RECOMMEND,
              });
            }}
          >
            추천일정
          </button>
        </div>
        <button
          type="button"
          className={cx('close')}
          aria-label="닫기"
          onClick={() => {
            setModal({ type: Modal.NULL, position: ModalPosition.RECOMMEND });
          }}
        />
      </div>
      <div
        className={cx('content', {
          as_chart: modal.type === Modal.FARE_CHART,
          as_recommend: modal.type === Modal.RECOMMEND,
        })}
      >
        {modal.type === Modal.FARE_CHART &&
          (selected.isDomestic ? (
            <ChartDomestic
              payload={{
                departureCity: {
                  code: selected.departureCity.iataCode,
                  name: selected.departureCity.cityName,
                  isDomestic: true,
                },
                arrivalCity: {
                  code: selected.arrivalCity.iataCode,
                  name: selected.arrivalCity.cityName,
                  isDomestic: true,
                },
                tourDepartureDate: selected.sdate1,
                tourReturnDate: selected.sdate2,
              }}
            />
          ) : (
            <ChartOverseas />
          ))}
        {modal.type === Modal.RECOMMEND && <RecommendedSchedule />}
        <div className={cx('footer')}>
          <div className={cx('Footer')}>
            <p className={cx('txt')}>
              <span className={cx('line')}>
                최근 조회된 결과로 업데이트 되며, 실제 예약
              </span>
              <wbr />
              <span className={cx('line')}>
                가능한 가격과 다를 수 있습니다.
              </span>
              <a
                className={cx('info')}
                href="#"
                title="더보기"
                onClick={e => {
                  e.preventDefault();
                  window.open(getHelpLink(window?.innerWidth));
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
